import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import queryString from 'query-string'

const UPDATED_NOTIFICATION_SETTINGS_PARAM = 'updatedNotificationSettings'

export default function useNotificationsUrlParams(revalidateSavedFilters: () => void) {
  const { hash } = useLocation()
  const history = useHistory()
  useEffect(() => {
    const hashParams = queryString.parse(hash)
    if (UPDATED_NOTIFICATION_SETTINGS_PARAM in hashParams) {
      history.replace({
        search: history.location.search,
        hash: ''
      })
      revalidateSavedFilters()
    }
  }, [hash, history, revalidateSavedFilters])
}
